import type { InternalAxiosRequestConfig } from "axios";
import axios from "axios";

import { REACT_APP_API_URL } from "../config";

export type ApiRequestConfig = InternalAxiosRequestConfig & { skipAuth?: boolean };

const normalizedBase = String(REACT_APP_API_URL ?? "").replace(/\/+$/, "");

/** Shared axios instance: base URL under `/api`, JSON default, optional Bearer from localStorage */
export const apiClient = axios.create({
  baseURL: normalizedBase ? `${normalizedBase}/api` : "/api",
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use((rawConfig) => {
  const config = rawConfig as ApiRequestConfig;
  if (!config.skipAuth) {
    const token = localStorage.getItem("auth_token");
    if (token) {
      config.headers = config.headers ?? {};
      Object.assign(config.headers, { Authorization: `Bearer ${token}` });
    }
  }
  return config;
});
